import _ from 'lodash'
// Utils
import {addAnalytic} from '../../lib/api'
import {keenClient} from '../../utils/analytics'
// Components
import QuestionAdImage from '../ads/question-ad-image'
import QuestionAdProfile from '../ads/question-ad-profile'
// Types
import type {PhotoGalleryAdProps} from '../../types/photo-gallery'
// Styles
import styles from './photo-gallery-ad.module.scss'

type GalleryAdVariant = 'scroll' | 'flow-grid' | 'flow-masonry'

interface Props extends PhotoGalleryAdProps {
  variant: GalleryAdVariant
}

const PhotoGalleryAd = ({
  entryKey,
  ballot,
  group,
  question,
  displayAd = null,
  variant,
}: Props) => {
  if (!displayAd || !_.includes(['DisplayAd', 'ProfileCard'], displayAd.adType)) return null

  const handleClick = (displayAd: NonNullable<PhotoGalleryAdProps['displayAd']>) => {
    if (ballot?.new_features?.enable_best_of_internal_analytics) {
      addAnalytic({
        ballot_id: ballot?._id,
        category_id: group?._id,
        category_name: group?.parent_category_name,
        sub_category_id: question?._id,
        sub_category_name: question?.name,
        ad_clicks: {
          ad_id: displayAd?._id,
          ad_name: displayAd?.name,
          event_type: 'chosenSubCategory-Ads-Click',
        },
      })
    } else {
      keenClient.recordEvent('Category-Ads-Click', {
        event_type: 'chosenSubCategory-Ads-Click',
        chosenSubCategory: question,
        ballot_id: ballot?._id,
        category_id: group?._id,
        category_name: group?.parent_category_name,
        chosenSubCategoryId: question?._id,
        chosenSubCategoryName: question?.name,
        ad_id: displayAd?._id,
        subcategoryAdName: displayAd?.name,
        subcategoryAdAdvertiserName: displayAd?.advertiser_name,
        ballot: ballot,
      })
    }
  }

  const variantClass = styles[`--${variant}`] || ''

  // Grid variant renders a simple linked image instead of the shared ad components
  if (variant === 'flow-grid') {
    return (
      <div
        key={entryKey}
        onClick={() => handleClick(displayAd!)}
        className={`${styles['photo-gallery-ad']} ${variantClass}`}
      >
        <a
          href={displayAd!.website_link}
          target='_blank'
          rel="noreferrer"
        >
          {displayAd!.mobile_image_path && (
            <img
              src={displayAd!.mobile_image_path}
              alt=""
            />
          )}
        </a>
      </div>
    )
  }

  return (
    <div
      key={entryKey}
      onClick={() => handleClick(displayAd!)}
      className={`${styles['photo-gallery-ad']} ${variantClass}`}
    >
      {displayAd!.adType === 'DisplayAd' && <QuestionAdImage ad={displayAd!} adHeightOverride={undefined}/>}
      {displayAd!.adType === 'ProfileCard' && <QuestionAdProfile ad={displayAd!}/>}
    </div>
  )
}

export default PhotoGalleryAd
